import React, { useState } from 'react';
import { Box, Typography, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { Instagram, LinkedIn, Pinterest, Twitter } from '@mui/icons-material';
import Navbar from './common/Navbar';
import Sidebar from './common/Sidebar';

const Layout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleHamburgerClick = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f5f7fb', overflow: 'hidden', maxWidth: '100vw' }}>
      <Navbar onHamburgerClick={handleHamburgerClick} />
      <Sidebar
        mobileOpen={isSidebarOpen}
        handleDrawerToggle={handleHamburgerClick}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          pt: { xs: '56px', md: '64px' },
          minHeight: '100vh',
          maxWidth: { xs: '100vw', md: 'calc(100vw - 260px)' },
          overflowX: 'hidden',
        }}
      >
        <Box sx={{ flex: 1, p: { xs: 1, sm: 2 }, overflowX: 'hidden' }}>
          {children}
        </Box>
        {/* Inline compact footer */}
        <Box
          component="footer"
          sx={{
            py: { xs: 1, sm: 1.5 },
            px: { xs: 1.5, sm: 4 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'center', sm: 'space-between' },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 0.5, sm: 1 },
            borderTop: '1px solid #eef0f6',
            textAlign: { xs: 'center', sm: 'left' },
          }}
        >
          <Typography sx={{ color: '#8b8fa3', fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>
            &copy; {new Date().getFullYear()} InfyU Labs. All rights reserved.
          </Typography>
          <Box display="flex" gap={0.5}>
            {[
              { icon: <Instagram sx={{ fontSize: 14 }} />, href: '#' },
              { icon: <LinkedIn sx={{ fontSize: 14 }} />, href: 'https://www.linkedin.com/company/infyu-labs/' },
              { icon: <Pinterest sx={{ fontSize: 14 }} />, href: '#' },
              { icon: <Twitter sx={{ fontSize: 14 }} />, href: '#' },
            ].map((item, idx) => (
              <IconButton
                key={idx}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                sx={{
                  color: '#8b8fa3',
                  width: 26,
                  height: 26,
                  '&:hover': { color: '#667eea', bgcolor: 'rgba(102,126,234,0.08)' },
                }}
              >
                {item.icon}
              </IconButton>
            ))}
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Typography
              component="a"
              href="mailto:hello@infyulabs.com"
              sx={{ color: '#8b8fa3', fontSize: '0.75rem', textDecoration: 'none', '&:hover': { color: '#667eea' } }}
            >
              hello@infyulabs.com
            </Typography>
            <Typography
              component="a"
              href="https://infyulabs.com/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#8b8fa3', fontSize: '0.75rem', textDecoration: 'none', '&:hover': { color: '#667eea' } }}
            >
              infyulabs.com
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
